const baseAPIHost = 'https://api.coreassist.devtest.gf.aws.scania.com.cn';

export const environment = {
  production: false,
  region: 'cn',
  apiUrl: `${baseAPIHost}/api`,
  wsUrl: baseAPIHost,
  redirectUrl: `${window.location.origin}`,
  useMock: false,
  msal: {
    com:{
      clientId: '6af74962-69eb-4446-b0bf-8cb6cb90d23a',
      authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
      tenantId: '3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
      scopes: ["api://6af74962-69eb-4446-b0bf-8cb6cb90d23a/coreassistapp.scope"]
    },
    cn:{
      clientId: 'a1a377c5-b748-4b6a-a94c-e114e5cab161',
      authority: 'https://login.partner.microsoftonline.cn/e71a154e-e269-46af-a3af-fdff3eab0663',
      tenantId: 'e71a154e-e269-46af-a3af-fdff3eab0663',
      scopes: ["api://a1a377c5-b748-4b6a-a94c-e114e5cab161/coreassistapp.scope"]
    },
    international:{
      clientId: '7c6212b0-ad36-4f2a-8f37-ac21827fb158',
      authority: 'https://login.microsoftonline.com/b5a920d6-7d3c-44fe-baad-4ffed6b8774d',
      tenantId: 'b5a920d6-7d3c-44fe-baad-4ffed6b8774d',
      scopes: ["api://7c6212b0-ad36-4f2a-8f37-ac21827fb158/coreassistapp.scope"]
    }
  }
}; 